import React, { useState } from 'react';
import { Info } from 'lucide-react';
import Tooltip from 'src/shared/components/tooltip/Tooltip';
import type { CatalogueLayer } from './catalogueLayers';
import LayerCredit from './LayerCredit';
import useCatalogueAttribution from './useCatalogueAttribution';

type CatalogueLayerCreditProps = {
    layer: CatalogueLayer;
    placement?: 'top' | 'right' | 'bottom' | 'left';
};

const CatalogueLayerCredit = ({ layer, placement = 'left' }: CatalogueLayerCreditProps) => {
    // Hover alone leaves the credit out of reach of a keyboard.
    const [focused, setFocused] = useState(false);
    const attribution = useCatalogueAttribution(layer.collectionId);

    // An empty tooltip opens for a dataset the catalogue has not answered for.
    if (!attribution) return null;

    return (
        <Tooltip content={<LayerCredit layer={layer} />} placement={placement} isOpen={focused}>
            <button
                type='button'
                aria-label={`Credit for ${layer.label}`}
                className='text-muted-foreground transition-colors hover:text-primary'
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
            >
                <Info size={13} />
            </button>
        </Tooltip>
    );
};

export default CatalogueLayerCredit;
